import { z } from "zod";

import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * `validateSearch` for `/my/chats`.
 *
 * `cid` in the URL is what makes a conversation linkable — a notification, an email, or
 * a browser back button all address one thread by the same key the API uses.
 *
 * Every key is top-level: unlike the Office Inbox this screen has no filter chips, so
 * there is no `filters[field][op]` bag to accept. The home is fixed by the member's
 * place context, and the one filter the screen offers — Unreads — is a bare `unread` key
 * rather than a `filters` entry. There is no `awaitingTeamReply`: whether the office owes
 * an answer is the office's queue to work, not a homeowner's.
 *
 * Lenient types on purpose: TanStack validates search with the CURRENT route's schema
 * and throws `SearchParamError` on a mismatch, which drops the whole page into the error
 * boundary. A strict `z.enum` on `view` would crash the screen on a stale link rather
 * than falling back — the component narrows instead (see [webapp-routing.md]).
 *
 * `view=archived` asks the list for the caller's Archived conversations; anything else is
 * the open list. A filter of the one list — `search` and `unread` apply on both sides of
 * it — kept as its own key rather than a filter entry because the pill row's view chip is
 * its one control. `unread=true` is the "Unreads" filter.
 *
 * `maskSearchFragment` is spread because any route a user can be on when a masked-dialog
 * opener fires must accept its keys, or the dialog silently no-ops.
 */
export const chatsSearchSchema = z.object({
  cid: z.string().optional(),
  search: z.string().optional(),
  view: z.string().optional(),
  unread: z.string().optional(),
  ...maskSearchFragment,
});
